<template>

  <div class="about-page">
    <Header></Header>
    <video-bg :sources="[videoLink]" img="someURL">
      <!-- If you want to add content here, a slot is waiting! -->
    </video-bg>
    <section class="team-section">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2 class="mb-3">Who We Are</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <p>Cardboard Stage is a collaborative platform that brings artists globally, together to connect, collaborate, and create original work with the aim to make the arts more accessible and inclusive. </p>
            <p>The innovative work born through our site is not constrained by the conventional stage, but rather we bring these pieces of art to unique spaces and new communities that do not have direct access to them. </p>
            <p>We provide a stage online for artists globally, to perform, create and most importantly, the opportunity to grow their network and monetize their talents through brand sponsorships.</p>
            <p>Inclusivity and representation are a major tenant in our mission. We redefine the art world by building a completely inclusive community and think outside the box to <strong>break down barriers</strong> that limit the expansion of the arts and of artists in these fields.</p>
            <p>At Cardboard Stage, we challenge tradition and aim to enable and empower artists to be the architect of their own success and the freedom to do what they do best. </p>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-12">
            <h2>Our Team</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 team-col" style="margin-bottom: 30px;" v-for="(list) in lists" v-bind:key="list.id">
            <div>
              <div class="team-img background-fit" :style="{ backgroundImage: `url(${imageUrl + list.images[0].bgImageFile})` }"></div>
              <a :href="list.linkedin" v-if="list.linkedin" target="_blank" class="social-icon">
                <img src="@/assets/img/linked_icon.svg"/>
              </a>
            </div>
            <h3>{{list.name}}</h3>
            <h4>{{list.designation}}</h4>
            <!--<ul class="social-contact list-inline">-->
              <!--<li>-->
                <!--<a href="mailto:me.pankaj.s@gmail.com">-->
                  <!--<img src="@/assets/img/media/mail.svg"/>-->
                <!--</a>-->
              <!--</li>-->
              <!--<li>-->
                <!--<a href="https://www.facebook.com/pakzy" target="_blank">-->
                  <!--<img src="@/assets/img/media/facebookIcon.svg"/>-->
                <!--</a>-->
              <!--</li>-->
              <!--<li>-->
                <!--<a href="https://www.linkedin.com/in/pankaj-sharma-9a995646/" target="_blank">-->
                  <!--<img src="@/assets/img/media/linkedin.svg"/>-->
                <!--</a>-->
              <!--</li>-->
            <!--</ul>-->
            <p>{{list.description}}</p>
          </div>
        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './Header'
import Footer from './Footer'
import backgroundUrl6 from '@/assets/img/image8.jpg'
import playIcon from '@/assets/img/playIcon.svg'
import videoLink from '@/assets/video/video2.mp4'
import axios from 'axios'
import VideoBg from 'vue-videobg'
import Vue from 'vue'
Vue.component('video-bg', VideoBg)

export default {
  name: 'About',
  components: {
    'Header': Header,
    'Footer': Footer
  },
  data () {
    return {
        lists: '',
        backgroundUrl6: backgroundUrl6,
        playIcon: playIcon,
        videoLink: videoLink,
        msg: 'Welcome to Your Vue.js App',
        imageUrl: process.env.imageUrl
    }
  },
    mounted () {
        axios
            .get('/getpeople')
            .then(response => {
                this.lists = response.data
            })
            .catch(error => console.log(error))

        // axios.post('/createteam', {
        //     name: 'AJ Ostrow',
        //     designation: 'Head of Tech',
        //     description: 'AJ Ostrow is a full-stack developer and entrepreneur from Seattle. He started in corporate data warehousing and data-driven visualization. Since, he co-founded Modde, works for Thinkwire, Stealth Trader and consults for McGill.'
        // }).then(res => res.data)

        // axios.put('/editteam', {
        //     id: '5dc8034d6791cd25f559e506',
        //     name: 'AJ Ostrow',
        //     designation: 'Head of Tech',
        //     description: 'AJ Ostrow is a full-stack developer and entrepreneur from Seattle. He started in corporate data warehousing and data-driven visualization. Since, he co-founded Modde, works for Thinkwire, Stealth Trader and consults for McGill.'
        // }).then(res => res.data)

    }
}
</script>



// WEBPACK FOOTER //
// src/components/About.vue